import Modal from 'react-modal';
import styled from 'styled-components';

import { useTranslation } from '@hooks';
import { ReturnContent, ProductInfoTable } from '@components/products/';
import { CloseButton, RightModal } from '@components/ui';
import { Caption2 } from '@components/styles/Typography';

Modal.setAppElement('#__next');

const DetailsModal = ({ closeDetailsModal, currentTab, details, sku }) => {
    const { t } = useTranslation();
    return (
        <RightModal
            isOpen={currentTab}
            closeModal={closeDetailsModal}
            noOverlay
            width="44vw"
        >
            <DetailWrapper>
                <CloseButton
                    close={closeDetailsModal}
                    right
                    top="42px"
                    padding="0"
                />
                {currentTab === 'details' && (
                    <ModalTitleWrapper>
                        <Caption2>{t('productDetails')}</Caption2>
                    </ModalTitleWrapper>
                )}
                {currentTab === 'returnPolicy' && (
                    <ModalTitleWrapper>
                        <Caption2>{t('returnPolicy')}</Caption2>
                    </ModalTitleWrapper>
                )}

                {currentTab === 'details' && (
                    <ProductInfoTable details={details} sku={sku} />
                )}

                {currentTab === 'returnPolicy' && <ReturnContent />}
            </DetailWrapper>
        </RightModal>
    );
};
const DetailWrapper = styled.div`
    width: fit-content;
    margin: 150px auto 0;
`;
const ModalTitleWrapper = styled.div`
    position: absolute;
    top: 36px;
    left: 30px;
    margin: 0;

    @media (max-width: 1024px) {
        left: 20px;
    }
`;

export default DetailsModal;
